import { API_BASE_URL } from '@/config/api';
import logoUrl from '@/assets/logo.webp';

// URL des Mitgliedsfotos; ohne hinterlegtes Foto das Vereinslogo
export const memberPhotoUrl = (id: number, photoVersion?: number | null): string =>
  photoVersion ? `${API_BASE_URL}/members/${id}/photo?v=${photoVersion}` : logoUrl;

// Verkleinert ein Bild im Browser auf höchstens `maxSize` Pixel Kantenlänge und
// gibt es als JPEG zurück – so bleiben die Fotos in der Datenbank klein.
export const resizeImage = (file: File, maxSize = 800, quality = 0.85): Promise<Blob> =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      const scale = Math.min(1, maxSize / Math.max(img.width, img.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject(new Error('Canvas nicht verfügbar'));
        return;
      }
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      canvas.toBlob(
        (blob) => (blob ? resolve(blob) : reject(new Error('Bild konnte nicht umgewandelt werden'))),
        'image/jpeg',
        quality,
      );
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Die Datei ist kein lesbares Bild'));
    };
    img.src = url;
  });
